import * as React from 'react';

import { twMerge } from 'utilities/src/twMerge';

import GenericIconProps from '../_icon.type';

export default function CheckboxIcon({ className = '', viewBox = '0 0 24 24', size }: GenericIconProps) {
  return (
    <svg className={twMerge(className, size)} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="6" fill="black" stroke="black" />
    </svg>
  );
}
